import { useQuery, ApolloError } from '@apollo/client';
import { useHirerAuth } from '@seek/hirer-auth-react';

import type { GetAccountContextQuery } from 'src/graphql/generated';
import { ACCOUNT_CONTEXT_QUERY } from 'src/graphql/gql_queries';
import type { UseQueryResponse } from 'src/types/types';
import { getDevContext } from 'src/utils/config';

export const useAccountContext =
  (): UseQueryResponse<GetAccountContextQuery | null> => {
    const { login } = useHirerAuth();
    const { loading, error, data } = useQuery<GetAccountContextQuery>(
      ACCOUNT_CONTEXT_QUERY,
    );
    if (loading) {
      return { loading, error, data: null };
    }

    if (error) {
      if (
        error.graphQLErrors?.find(
          (gqlError) => gqlError.extensions?.code === 'UNAUTHENTICATED',
        )
      ) {
        if (getDevContext()) {
          throw new Error('Your local auth token is expired or invalid');
        }
        login();
      }
      return { loading: false, error, data: null };
    }

    const currentAdvertiser = data?.currentAdvertiser;

    if (!currentAdvertiser) {
      login();

      return {
        loading: false,
        error: new ApolloError({ errorMessage: 'No advertiser selected' }),
        data: null,
      };
    }

    if (currentAdvertiser.__typename === 'MissingAdvertiserIdClaimError') {
      return {
        loading: false,
        error: new ApolloError({ errorMessage: 'Missing advertiserId' }),
        data: null,
      };
    }

    return { loading, error, data };
  };
